import * as actionTypes from "./actionTypes";
import {
  getPerformanceInterviewAndFeedbackAPI,
  previewInterviewAndFeedbackAPI,
  getInterviewAndFeedbackAPI
} from "@icarius-connection/api";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { getLocalizedString, getErrorStringFromServerError } from "@icarius-localization/strings";
import { downloadBlob } from "@icarius-utils/download";
import { getFileExtension, getFileName } from "@icarius-utils/fileUpload";

const errorHandler = (e, dispatch) => {
  let errorString = "";
  switch (e.response?.data?.status) {
    case "INVALID_DATA":
    case "VALIDATION_ERROR":
      errorString = getLocalizedString("validationError");
      break;
    default:
      errorString = getErrorStringFromServerError(e);
      break;
  }
  dispatch(openSnackbarAction({ msg: errorString, severity: "error" }));
}


export const getPerformanceInterviewAndFeedbackAction = () => async (dispatch) => {
  dispatch({ type: actionTypes.GET });
  try {
    let response = await getPerformanceInterviewAndFeedbackAPI();

    let data = response.data && response.data.data;
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.GET_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.GET_FULFILLED,
      payload: {
        data,
      },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};

export const getSummaryAction = (process, employeeCode) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_INTERVIEW_FEEDBACK });
  try {
    let params = new URLSearchParams();
    params.set("processCode", process);
    params.set("evaluatedCode", employeeCode);

    let response = await getInterviewAndFeedbackAPI(`?${params.toString()}`);

    let data = response.data && response.data.data;
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.GET_INTERVIEW_FEEDBACK_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.GET_INTERVIEW_FEEDBACK_FULFILLED,
      payload: {
        data,
      },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_INTERVIEW_FEEDBACK_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};

export const previewDocumentsAction = (data) => async (dispatch) => {
  dispatch({ type: actionTypes.PREVIEW_INTERVIEW_FEEDBACK });
  try {
    let response = await previewInterviewAndFeedbackAPI(data);

    if (response.status !== 200) {
      dispatch({ type: actionTypes.PREVIEW_INTERVIEW_FEEDBACK_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({ type: actionTypes.PREVIEW_INTERVIEW_FEEDBACK_FULFILLED });
    let title = response.headers["x-content-namefile"];
    downloadBlob(response.data, getFileExtension(title), getFileName(title));

    return response;
  } catch (e) {
    dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
    dispatch({ type: actionTypes.PREVIEW_INTERVIEW_FEEDBACK_REJECTED, payload: e });
  }
};